// extracted by mini-css-extract-plugin
export default {"review-table":"ViewReviewRequest_review-table__uCAW6","row":"ViewReviewRequest_row__u6pxR","header":"ViewReviewRequest_header__l2+KT","tool-bar":"ViewReviewRequest_tool-bar__Hg0WU"};